import React from 'react';
import './style.css';

export default function Checkbox({ value, onChange, name, checked, className }) {
    return (
        <div className={`checkbox ${className}`}>
            <input name={name} type="checkbox" value={value} onChange={onChange} checked={checked} />
            <span></span>
        </div>
    );
}
